import {Component} from '@angular/core';
/**
 * \@title Datepicker Touch
 */
export class DatepickerTouchExample {
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'datepicker-touch-example',
  templateUrl: 'datepicker-touch-example.html',
  styleUrls: ['datepicker-touch-example.css'],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function DatepickerTouchExample_tsickle_Closure_declarations() {
/** @type {?} */
DatepickerTouchExample.decorators;
/**
 * @nocollapse
 * @type {?}
 */
DatepickerTouchExample.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
